import React, { useState, useCallback } from 'react';
import { branch, renderComponent, compose, withProps } from 'recompose';
import { find, prop, propEq } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';
import { CategoryContext } from '../context';
import Tabs from './Tabs';
import Category from './Category';
import Title from './CategoryTitle';
import style from './index.scss';

export const GamesCategory = ({ status, id, title, games, expandedCategory, setExpandedCategory }) => (
    <CategoryContext.Provider value={{ status, expandedCategory, setExpandedCategory }}>
        <Category
            cid={id}
            title={title}
            gameCodes={games}
            className={style.category}
        />
    </CategoryContext.Provider>
);

export const GamesForMobile = ({ rules, activeTab, tabClick, id, className = '', ...rest }) => (
    <div className={`${className} ${style.container}`}>
        <Tabs onChange={tabClick} activeTab={activeTab} tabs={rules} />
        <GamesCategory key={id} {...{ id, ...rest }} />
    </div>
);

export const GamesForDesktop = ({ rules, className = '' }) => {
    const [expandedCategory, setExpandedCategory] = useState(null);
    return (
        <div className={`${className} ${style.container}`}>
            {rules.map((rule) => {
                const { status, endDateTime: endTime, startDateTime: startTime, games, id } = rule;
                const title = <Title {...{ status, endTime, startTime }} />;
                return <GamesCategory
                    key={id}
                    id={id}
                    status={status}
                    title={title}
                    games={games}
                    expandedCategory={expandedCategory}
                    setExpandedCategory={setExpandedCategory}
                />;
            })}
        </div>
    );
};

export default compose(
    withProps(
        ({ rules }) => {
            let sortedRules = rules;
            if (rules.length > 1) {
                // do the unique check.
                sortedRules = rules.sort((a, b) => a.millisecondsTillRuleStart - b.millisecondsTillRuleStart);
                const firstRule = sortedRules[0];
                const restRules = sortedRules.slice(1);
                const finalRules = [firstRule];

                firstRule.games
                    .map(g => restRules.map((r, rri) => restRules[rri].games = r.games.filter(name => name !== g)));
                sortedRules = finalRules.concat(restRules);
            }
            return {
                rules: sortedRules
            };
        }
    ),
    branch(
        () => useDeviceSelector(prop('isDesktop')),
        renderComponent(GamesForDesktop)
    ),
    withProps(
        ({ rules }) => {
            // make games appear only once from each tab and between tabs
            const [activeTab, setActiveTab] = useState(rules[0].id);
            const getRule = id => find(
                // this is getting the prop "id" from the object that gets parsed in
                // (though no clue on what the obj is) and checking the value
                // against the id, returns a boolean accordingly
                propEq('id', id),
                rules);
            const tabClick = useCallback((id) => { // assigning status to the rule based on id.
                setActiveTab(id);
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [activeTab]);
            const { id, games, status } = getRule(activeTab);
            return {
                id,
                games,
                status,
                activeTab,
                tabClick,
                rules
            };
        }
    )
)(GamesForMobile);
